import { Theme, css } from '@emotion/react';

import { Spacing, Typography } from 'chatie-design-system';

const tagListCSS = css`
  display: flex;
  flex-wrap: wrap;
  gap: ${Spacing.xsmall}px;
`;

const tagChipCSS = (theme: Theme) => css`
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0 ${Spacing.small}px;
  border-radius: 999px;
  background: ${theme.colors.main50};
  color: ${theme.colors.main500};
  ${Typography.body12};
  font-weight: 600;

  &:active {
    opacity: 0.8;
  }
`;

type CommunityTagListProps = {
  tags?: string[];
  onTagClick?: (tag: string) => void;
};

const CommunityTagList = ({ tags, onTagClick }: CommunityTagListProps) => {
  if (!tags?.length) {
    return null;
  }

  return (
    <div css={tagListCSS}>
      {tags.map((tag) => (
        <span
          key={`community-tag-${tag}`}
          css={tagChipCSS}
          onClick={(e) => {
            if (!onTagClick) {
              return;
            }

            e.stopPropagation();
            onTagClick(tag);
          }}
        >
          #{tag}
        </span>
      ))}
    </div>
  );
};

export default CommunityTagList;
